export const withQuery = (url: string, search: URLSearchParams) => {
	if (search.toString().length) {
		return `${url}?${search.toString()}`;
	}
	return url;
};

export const getDateFromAgeFormat = (age: string | number, separator = '-') => {
	const newAge: string = typeof age === 'number' ? String(age) : age;
	const birthdayYear = new Date().getFullYear() - parseInt(newAge);
	const currentDay = new Date().getDate();
	const currentMonth = new Date().getMonth() + 1;

	return [birthdayYear, currentMonth, currentDay].join(separator);
};

export const createBdayFromAge = (age: number) => {
	return `${new Date().getFullYear() - age}-01-01`;
};

export const getSearchParamsFromAsPath = (asPath: string): URLSearchParams => {
	const [, searchAndHash = ''] = asPath.split('?');
	const [search = ''] = searchAndHash.split('#');
	return new URLSearchParams(search);
};
